import "./index.es46.js";
import { useAPI as f } from "./index.es47.js";
import { usePresetDatesPLMapbox as G } from "./index.es241.js";
import { useQueries as q, useQuery as F } from "@tanstack/react-query";
import * as P from "@turf/turf";
import "./index.es4.js";
import "./index.es20.js";
import { usePLMapboxMapId as I } from "./index.es21.js";
import "react";
import { usePLMapboxLayersStore as v } from "./index.es12.js";
import "./index.es6.js";
import "./index.es99.js";
import "react/jsx-runtime";
import "@placer-ui/components";
import "./index.es203.js";
import "./index.es204.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "./index.es175.js";
import "./index.es176.js";
import { AsyncQueue as L } from "./index.es242.js";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import K from "qs";
import "react-map-gl";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es82.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es131.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "@sentry/react";
import "./index.es43.js";
import "lodash";
import "./index.es84.js";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es72.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "./index.es209.js";
import "./index.es103.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
const R = ({
  mode: i,
  size: a,
  entity_id: y,
  within_distance: m,
  start_date: n,
  end_date: g
}) => ["getGeoTradeAreaPolygon", i, a, y, m, n, g], B = new L(6), Hr = ({
  mode: i,
  within_distance: a,
  entities: y,
  sizes: m,
  start_date: n,
  end_date: g
}) => {
  const { getGeoTradeAreaPolygon: u } = f(), { data: r } = G(), o = n ?? (r == null ? void 0 : r["last-12-months"].start), e = g ?? (r == null ? void 0 : r["last-12-months"].end), b = async (t) => {
    const { entity_id: p, entity_type: d, mode: c, size: T, within_distance: A, start_date: C, end_date: M } = t, Q = async () => await u({
      entity_id: p,
      entity_type: d,
      mode: c,
      size: T,
      within_distance: A,
      start_date: C,
      end_date: M
    }), w = await B.add(Q), x = P.rewind(w.data.data);
    return {
      geojson: P.feature(x),
      status: w.data.status,
      type: w.data.data.type,
      trade_area_variant: w.data.trade_area_variant
    };
  }, s = m.flatMap(
    (t) => y.map(({ id: p, type: d }) => ({
      size: t,
      queryKey: R({
        mode: i,
        size: t,
        entity_id: p,
        within_distance: a,
        start_date: o,
        end_date: e
      }),
      queryFn: () => b({
        entity_id: p,
        entity_type: d,
        mode: i,
        size: t,
        within_distance: a,
        start_date: o,
        end_date: e
      }),
      retry: 20,
      enabled: !!p && !!d && !!o && !!e
    }))
  ), _ = q({
    queries: s.map((t) => ({ ...t }))
  }), h = _.reduce((t, p, d) => {
    const { size: c } = s[d];
    return t[c] || (t[c] = []), p.data && t[c].push(p.data), t;
  }, {}), l = _.some((t) => t.isFetching);
  return { data: h, rawQueryData: _, isFetching: l };
}, jr = ({
  entity_id: i,
  entity_type: a,
  sizes: y,
  geoid_type: m,
  start_date: n,
  end_date: g
}) => {
  const { getGeoTradeAreaCbgs: u, getGeoTradeAreaChainCbgs: r } = f(), { data: o } = G(), e = q({
    queries: y.map((s) => {
      const _ = n ?? (o == null ? void 0 : o["last-12-months"].start), h = g ?? (o == null ? void 0 : o["last-12-months"].end);
      return {
        queryKey: [
          "useGetGeoTradeAreaCbg",
          i,
          s,
          m,
          _,
          h
        ],
        queryFn: async () => {
          let l, t = 200, p;
          if (a === "chain" || a === "tags")
            l = (await r({
              entity_id: i,
              entity_type: a,
              size: s,
              geoid_type: m,
              start_date: _,
              end_date: h
            })).weighted_cbgs.reduce((c, T) => {
              const { id: A, w: C } = T;
              return c[A] = {
                code: A,
                weight: C
              }, c;
            }, {});
          else {
            const d = await u({
              entity_id: i,
              entity_type: a,
              size: s,
              geoid_type: m,
              start_date: _,
              end_date: h
            });
            l = d.data.cbgs.reduce(
              (c, T) => {
                const { code: A } = T;
                return c[A] = T, c;
              },
              {}
            ), p = d.data.trade_area_variant, t = d.data.status;
          }
          return {
            cbgs: l,
            status: t,
            trade_area_variant: p
          };
        }
      };
    })
  }), b = e.some((s) => s.isFetching);
  return { data: e, isFetching: b };
}, Sr = ({
  layerGroupId: i
}) => {
  const a = I(), { getChainTilesTTAMetadata: y, getChainTilesTaBatchId: m } = f(), { nationwide_chain_id: n, type: g } = v(
    (u) => {
      var r, o;
      return (o = (r = u.maps) == null ? void 0 : r[a]) == null ? void 0 : o.combinedLayersData[i];
    }
  );
  return F({
    queryKey: [n, g],
    queryFn: async () => {
      const u = await m(), r = await y({
        entityId: n,
        batchId: u.matav_version_id
      });
      return {
        batchId: u.matav_version_id,
        maxzoom: r.maxzoom
      };
    }
  });
}, kr = ({
  layerGroupId: i,
  start_date: a,
  end_date: y,
  enabled: m = !0,
  ...n
}) => {
  const g = I(), { getGeoTradeAreaHeatmap: u } = f(), { id: r, type: o } = v(
    (h) => {
      var l, t;
      return (t = (l = h.maps) == null ? void 0 : l[g]) == null ? void 0 : t.combinedLayersData[i];
    }
  ), { data: e } = G(), b = K.stringify({
    ...n
  }), s = a ?? (e == null ? void 0 : e["last-12-months"].start), _ = y ?? (e == null ? void 0 : e["last-12-months"].end);
  return F({
    queryKey: [r, b, s, _],
    queryFn: async () => await u({
      entity_id: r,
      entity_type: o,
      start_date: s,
      end_date: _,
      resolution: "nationwide",
      ...n
    }),
    enabled: m
  });
};
export {
  R as getTradeAreaReactQueryKey,
  Sr as useGetChainTilesMetadata,
  jr as useGetGeoTradeAreaCbg,
  kr as useGetGeoTradeAreaHeatmap,
  Hr as useGetGeoTradeAreaPolygon
};
//# sourceMappingURL=index.es113.js.map
